/**
 * AdminPage React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';


// application
import {updateViewProperty} from "../../redux/view/actions";
import AdminServerLogPanel from "./AdminServerLogPanel";
import AdminHistoryPanel from "./AdminHistoryPanel";
import AdminReduxStatePanel from "./AdminReduxStatePanel";
import AdminDataTransferPanel from "./AdminDataTransferPanel";
import AdminServiceCommandPanel from "./AdminServiceCommandPanel";


const tabs = [
    {
        label: "Historie",
        requires: "openAdminDashboard",
        element: AdminHistoryPanel
    },
    {
        label: "Datentransfer",
        requires: "exportDatabase",
        element: AdminDataTransferPanel
    },
    {
        label: "Log",
        requires: "openAdminDashboard",
        element: AdminServerLogPanel
    },
    {
        label: "Wartung",
        requires: "executeServiceCommands",
        element: AdminServiceCommandPanel
    },
    {
        label: "Applikationsstatus",
        requires: "debugApplication",
        element: AdminReduxStatePanel
    },
];


/**
 * AdminPage is the page for the admin dashboard
 */
class AdminPage extends React.Component {

    changeTab(index) {
        this.props.updateViewProperty("adminSection", "tabIndex", index);
    }

    render() {

        return (
            <div>
                <Tabs value={this.props.tabIndex} onChange={(event, index) => this.changeTab(index)}>
                    {this.props.tabs.map(tab => <Tab key={tab.index} label={tab.label} value={tab.index} />)}
                </Tabs>

                <div className={this.props.classes.tabContent}>
                    {this.renderCurrentTab()}
                </div>
            </div>
        );
    }

    renderCurrentTab() {

        const tabs = this.props.tabs.filter(
            tab => tab.index === this.props.tabIndex
        );
        const tab = tabs[0];
        if (!tab) return undefined;

        const TabElement = tab.element;
        return <TabElement/>;
    }
}


const styles = theme => ({
    tabContent: {
        marginTop: theme.spacing.unit
    }
});

const mapStateToProps = state => {

    const userPrivileges = state.authorization.userPrivileges || {};

    return {
        tabs: tabs.map(
            // add tab indexes automatically
            (tab, index) => ({...tab, index: index})
        ).filter(
            // and only show tabs the current user is allowed to see
            tab => userPrivileges[tab.requires]
        ),
        tabIndex: state.view.adminSection.tabIndex || 0
    }
};

export default connect(mapStateToProps, {updateViewProperty})(withStyles(styles)(AdminPage));
